import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import { Modal } from "antd";
import {
    RiCheckboxCircleLine,
    RiAlertLine,
    RiInformationLine,
} from "react-icons/ri";
// Auth Related Methods
import {
    postAdd,
    getParamsList,
    postEdit,
    postDelete,
    getList,
    postFormData,
} from "../../../helpers/Helper";
import {
    apiError,
    loanListSuccessful,
    loanByIDSuccessful,
    getloanList, isModelVisible
} from "./loan.slice";



function* LoanList({ payload }) {
    var data = payload;
    var params = {};
    for (const k in data) {
        if (Object.hasOwnProperty.call(data, k)) {
            if (k === "currentSort" || k === "sortOrder") {
                params.ordering = data.sortOrder + data.currentSort;
            } else {
                if (data[k] != "" && k != null && k != "no_of_pages") {
                    if (k == "start_date") {
                        params[k] = moment(data[k]).format("YYYY-MM-DD");
                    } else if (k == "end_date") {
                        params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD");
                    } else {
                        params[k] = data[k];
                    }
                }
            }
        }
    }
    try {
        const response = yield call(getParamsList, "/users/loanrequest/", params);
        yield put(loanListSuccessful(response));
    } catch (error) {
        yield put(apiError(error));
    }
}

function* LoanByID({ payload }) {
    try {
        const response = yield call(
            getParamsList,
            "/users/loanrequest/" + payload.row.id,
            {}
        );
        yield put(loanByIDSuccessful({ response, type: payload.type }));
    } catch (error) {
        yield put(apiError(error));
    }
}


function* AddLoan({ payload }) {
    try {
        if (payload.id === 0 || payload.id === null || payload.id === undefined) {
            const response = yield call(postAdd, "/users/loanrequest/", payload);
            if (response.status === 201) {
                Modal.success({
                    icon: (
                        <span className="remix-icon">
                            <RiCheckboxCircleLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Your Loan Added Successfully.!
                            </p>
                        </div>
                    ),
                });
                yield put(getloanList({ page: 1, search: "", page_size: 10 }));
                yield put(isModelVisible(false));
            } else {
                Modal.error({
                    icon: (
                        <span className="remix-icon">
                            <RiAlertLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Sorry! Unable to added Loan. Please try again!
                            </p>
                        </div>
                    ),
                });
            }
        } else {
            const response = yield call(
                postEdit,
                "/users/loanrequest/" + payload.id,
                payload
            );
            if (response.status === 200) {
                Modal.success({
                    icon: (
                        <span className="remix-icon">
                            <RiCheckboxCircleLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Your Loan Edited Successfully.!
                            </p>
                        </div>
                    ),
                });
                yield put(getloanList({ page: 1, search: "", page_size: 10 }));
                yield put(isModelVisible(false));
            } else {
                Modal.error({
                    icon: (
                        <span className="remix-icon">
                            <RiAlertLine />
                        </span>
                    ),
                    title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                    content: (
                        <div>
                            <p className="hp-p1-body hp-text-color-black-80">
                                Sorry! Unable to edit Laon. Please try again!
                            </p>
                        </div>
                    ),
                });
            }
            // yield put(vehiclesAddSuccessful(null));
        }
    } catch (error) {
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),

            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        Sorry! Getting from server side issue!
                    </p>
                </div>
            ),
        });
        yield put(apiError(error));
    }
}


function* watchGetLoanList() {
    yield takeEvery("loan/getloanList", LoanList);
}
export function* watchGetLoanByID() {
    yield takeEvery("loan/getloanByID", LoanByID);
}

export function* watchLoanAdd() {
    yield takeEvery("loan/loanAdd", AddLoan);
}
// export function* watchVisitDelete() {
//     yield takeEvery("visit/visitDelete", DeleteVisit);
// }
function* loanSaga() {
    yield all([
        fork(watchGetLoanList),
        fork(watchGetLoanByID),
        fork(watchLoanAdd),
        // fork(watchVisitDelete),
    ]);
}

export default loanSaga;
